var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('ProductCard',{attrs:{"product":_vm.product,"is-from-inventory":_vm.isFromInvertory}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }